import type { SVGProps } from 'react';

// Square emblem used in the header.
// Inlined instead of fetched from /public: the markup is part of the first paint
// and costs no extra round trip (see AGENTS.md → Performance).
export function LogoEmblem(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M36 36H0V0H36V36ZM1.7998 34.2002H34.2002V1.7998H1.7998V34.2002ZM12.8379 25.1787L10.3857 24.2598V31.0762H4.9502V26.9375L10.3857 23.4463L12.8379 25.1787ZM17.3926 6.30078L19.6328 9.02441L17.3926 7.2168V18.9131L22.8047 15.4785V15.4795L25.251 18.4209L22.8047 16.3848V31.0762H13.8164V8.83398L17.3906 6.2998H17.3926V6.30078ZM31.0498 25.6006L28.8682 23.9746V31.0762H26.2822V26.0928L28.8682 22.9961L31.0498 25.6006Z"
                fill="white"
            />
        </svg>
    );
}
